import { defineMessages } from 'react-intl';

const translations = {
  executeRefund: {
    id: 'actions.refund',
    defaultMessage: 'Refund',
    description: 'label of the execute refund action in the payments section',
  },
  confirmExecuteRefund: {
    title: {
      id: 'pages.transactionDetails.confirmExecuteRefund.title',
      defaultMessage: 'Refund payment',
      description:
        'title on the confirmation of the execution of the refund on the transaction details page',
    },
    description: {
      id: 'pages.transactionDetails.confirmExecuteRefund.description',
      defaultMessage: 'Are you sure you want to refund this payment?',
      description:
        'description on the confirmation of the execution of the refund on the transaction details page',
    },
    actions: {
      park: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel action',
      },
      execute: {
        id: 'actions.refund',
        defaultMessage: 'Refund',
        description: 'label of the refund action',
      },
    },
  },
  feedback: {
    paymentRefunded: {
      id: 'pages.transactionDetails.feedback.paymentRefunded',
      defaultMessage: 'Payment refunded',
      description: 'label of the payment refunded ',
    },
    paymentNotRefunded: {
      id: 'pages.transactionDetails.feedback.paymentNotRefunded',
      defaultMessage: 'Payment could not be refunded',
      description: 'label of the payment refunded ',
    },
  },
};

export default defineMessages(translations);
